const DEMO_MODE_STORAGE_KEY = 'llp_demo_mode';

export const readDemoModePreference = () => {
  try {
    return sessionStorage.getItem(DEMO_MODE_STORAGE_KEY) === 'true';
  } catch {
    return false;
  }
};

export const writeDemoModePreference = (enabled) => {
  try {
    if (enabled) {
      sessionStorage.setItem(DEMO_MODE_STORAGE_KEY, 'true');
    } else {
      sessionStorage.removeItem(DEMO_MODE_STORAGE_KEY);
    }
  } catch {
    // ignore storage failures
  }
};

export const clearDemoModePreference = () => writeDemoModePreference(false);
